// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WI-y","type":"styles_type__2C3Hb","choices":"styles_choices__1sGZg"};